import React from 'react';
import PropTypes from 'prop-types';

// Import components
import './headlineModule.scss';

const HeadlineModuleView = (props) => {
  const HeadlineTag = `h${props.priority}`;
  return (
    <div className="m-article-module">
      <HeadlineTag className={props.biggerSpacing ? 'm-headline-module m-headline-module--spacing' : 'm-headline-module'}>
        {props.children}
      </HeadlineTag>
    </div>
  );
};

HeadlineModuleView.propTypes = {
  priority: PropTypes.string,
  biggerSpacing: PropTypes.bool,
  children: PropTypes.node,
};

HeadlineModuleView.defaultProps = {
  priority: '2',
  biggerSpacing: false,
  children: null,
};

export default HeadlineModuleView;




// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/HeadlineModule/HeadlineModuleView.jsx